/* istanbul ignore file */
/**
 * Created by gboue on 8/24/22
 * File: StatusRenderer
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { VFC, useMemo } from 'react'
import { Body } from '@panwds/react-ui'
import { CircleCheckIcon, SyncIcon, RiskCriticalIcon } from '@panwds/icons'
import {
  LABEL_OWNERS_STATUS_NA,
  LABEL_OWNERS_STATUS_PENDING,
  LABEL_OWNERS_STATUS_VERIFIED,
  LABEL_OWNERS_STATUS_WARNING
} from '../../../../../constants/LabelConstants'
import { IDP_OWNER_STATUS } from '../../../../../constants/IAMConstants'
import { getVarValue } from '../../../../../../common/utils/Sparky'
import { FF_ENABLE_VERIFIED_WARNING } from '../../../../../../common/utils/FeatureFlags'

const enableVerifiedWarning = getVarValue(FF_ENABLE_VERIFIED_WARNING, false)

/**
 *   Owner status renderer
 */
const StatusRenderer: VFC<any> = ({ row, value }) => {

  const Icon = useMemo(() => {
    switch (value) {
      case IDP_OWNER_STATUS.PENDING:
        return SyncIcon
      case IDP_OWNER_STATUS.VERIFIED:
        return CircleCheckIcon
      case IDP_OWNER_STATUS.WARNING:
        return enableVerifiedWarning ? RiskCriticalIcon : CircleCheckIcon
      default:
        return null
    }
  }, [value])

  const label = useMemo(() => {
    switch (value) {
      case IDP_OWNER_STATUS.PENDING:
        return LABEL_OWNERS_STATUS_PENDING
      case IDP_OWNER_STATUS.VERIFIED:
        return LABEL_OWNERS_STATUS_VERIFIED
      case IDP_OWNER_STATUS.WARNING:
        return enableVerifiedWarning ? LABEL_OWNERS_STATUS_WARNING : LABEL_OWNERS_STATUS_VERIFIED
      default:
        return LABEL_OWNERS_STATUS_NA
    }
  }, [value])

  const colorCls = useMemo(() => {
    switch (value) {
      case IDP_OWNER_STATUS.PENDING:
        return 'cm-text-gray-300'
      case IDP_OWNER_STATUS.VERIFIED:
        return 'cm-text-green-400'
      case IDP_OWNER_STATUS.WARNING:
        return enableVerifiedWarning ? 'cm-text-blue-400' : 'cm-text-green-400'
      default:
        return undefined
    }
  }, [value])

  return (
    <div className='tw-flex tw-gap-2 tw-items-center'>
      {Icon && <Icon className={colorCls} size='sm' />}
      <Body size="lg" addClassName='tw-truncate'>{label}</Body>
    </div>
  )
}

StatusRenderer.propTypes = {}
export default StatusRenderer
